import { BrowserRouter } from "react-router-dom"
import { Container } from "./styles"
import HeroImage from "../../assets/hero.webp"
import { NavHashLink } from "react-router-hash-link"

export function Hero(){
  return(
    <Container id="home">
      <div className="hero-text">
          <h1>Cristina Jover Navarro</h1>
          <h3>Desarrolladora Front-End</h3>
          <p className="small-resume">¡Hola! Si has llegado aquí buscando un desarrollador web mayoritariamente <abbr title="La parte visual y de interacción con el usuario">Front-end</abbr>, con conocimientos de <abbr title="La lógica que tienen detrás las páginas web">Back-end</abbr> y con un background relacionado con la comunicación y el diseño, has llegado al lugar adecuado. Tengo experiencia de trabajo en el sector educativo, en agencia de marketing y en una start-up tecnológica. Si quieres conocer mi trayectoria con más detalle echa un vistazo a mi CV.</p>
            <BrowserRouter>
              <a href="#contacto" className="button">Contacto</a>
            </BrowserRouter>
      </div>
      <div className="hero-image">
          <img src={HeroImage} alt="Cristina Jover, foto de presentación"/>
      </div>
    </Container>
  )
}
